import(/* webpackMode: "eager", webpackExports: ["MetaPixel"] */ "/vercel/path0/web/components/analytics/meta-pixel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/vercel/path0/web/components/analytics/posthog-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteHeader"] */ "/vercel/path0/web/components/sections/site-header.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\",\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/app/globals.css");
